<form (ngSubmit)="onSubmit(EditPartnerForm)" #EditPartnerForm="ngForm">
<p-dialog 
    [(visible)]="displayDialog" 
    [modal]="true" 
    [positionTop]="50"
    [maximizable]="true"
    (onHide)="dialogClose()" 
    (onShow)="dialogOpen()">
    <p-header>
        <b>Edit Partner : {{partnerName}}</b>
    </p-header>
    <div class="dialog-content">
        <app-partner-details [relationshipId] = "relationshipId" (onAssetGroupChange)="assetGroupChange($event)" (onChange)="partnerDetailsChange($event)"
        (onPrivilegeChange)="onPrivilegeChange($event)" [refresh]="false"></app-partner-details>
    </div>
    <p-footer>
        <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="cancelDialog()"></button>
        <button pButton type="submit" label="{{processing ? 'Processing' : 'Save'}}" [disabled]="selectedGroup?.length <= 0 || selectedItemsNow?.length <=0 || processing" ></button>
    </p-footer>
</p-dialog>
</form>
